import { render, staticRenderFns, recyclableRender, components } from "./u-time-line-item.vue?vue&type=template&id=dba4c432&scoped=true&"
var renderjs
import script from "./u-time-line-item.vue?vue&type=script&lang=js&"
export * from "./u-time-line-item.vue?vue&type=script&lang=js&"
import style0 from "./u-time-line-item.vue?vue&type=style&index=0&id=dba4c432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba4c432",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-time-line-item/u-time-line-item.vue"
export default component.exports